import React from 'react';
import {
  Calendar,
  CalendarDays,
  Stethoscope,
  Building2,
  LayoutGrid,
  ClipboardList,
  BarChart3,
  Settings,
  RefreshCw,
  CalendarCheck,
  Eye,
  EyeOff,
  FileText,
  Shield,
  Database,
  Download,
  Upload,
  Trash2,
  Zap,
  Users,
  MapPin,
  Clock,
  Activity,
  Hospital,
  Sparkles,
  Lock,
  ArrowRight,
} from 'lucide-react';
import './AppIcon.css';

const ICONS = {
  logo: Building2,
  schedule: CalendarDays,
  doctors: Stethoscope,
  hospitals: Hospital,
  slots: LayoutGrid,
  availability: ClipboardList,
  analytics: BarChart3,
  settings: Settings,
  refresh: RefreshCw,
  today: CalendarCheck,
  showSlots: Eye,
  hideSlots: EyeOff,
  form: FileText,
  overview: Activity,
  calendar: Calendar,
  location: MapPin,
  time: Clock,
  users: Users,
  export: Download,
  backup: Database,
  restore: Upload,
  cleanup: Trash2,
  optimize: Zap,
  ai: Sparkles,
  lock: Lock,
  arrow: ArrowRight,
  privacy: Lock,
  terms: FileText,
  support: Users,
  shield: Shield,
};

/**
 * Unified SVG icons — larger, crisp, consistent stroke.
 * @param {string} name - key from ICONS map
 * @param {number} [size=24]
 * @param {string} [className]
 */
const AppIcon = ({ name, size = 24, className = '', strokeWidth = 2, ...rest }) => {
  const Icon = ICONS[name];
  if (!Icon) return null;
  return (
    <Icon
      size={size}
      strokeWidth={strokeWidth}
      className={`app-icon ${className}`.trim()}
      aria-hidden="true"
      {...rest}
    />
  );
};

export default AppIcon;
